@if (!isReadOnly()) {
  <div class="field-buckets__add-button">
    <xi-icon-button icon="add_circle" (onClick)="onAddItem()"></xi-icon-button>
  </div>
}
<form *transloco="let t; prefix: 'field-buckets'" [formGroup]="form">
  @for (row of tableRows(); track row; let i = $index) {
    <div [formGroup]="row" class="field-buckets__item-container">
      <!-- We need this handling b/c otherwise we could not identify the selected radio -->
      @if (hasRadioSelect()) {
        <div class="field-buckets__item-radio">
          <xi-radio
            color="orca"
            [checked]="selectedBucketIndex() === i"
            (onChange)="handleSelection(i)"
          ></xi-radio>
        </div>
      }

      <div class="field-buckets__item">
        <div class="field-buckets__item-left">
          <div class="field-buckets__row">
            <label [id]="'bucket-name-' + i">{{ t('bucket-name') }}</label>
            <div class="field-buckets__top-row-input">
              <xi-input-field
                formControlName="bucketName"
                [inputId]="'bucket-name-' + i"
                (onBlur)="updateErrorSignal()"
              ></xi-input-field>
            </div>
          </div>

          <div class="field-buckets__row">
            <label [id]="'min-value-' + i">{{ t('min') }}</label>
            <xi-input-field
              type="number"
              formControlName="minimumValue"
              [inputId]="'min-value-' + i"
              [step]="numericStep()"
              (onBlur)="updateErrorSignal()"
              (onChange)="onNumericValueChange(row, 'minimumValue', $event.detail.target.value)"
            ></xi-input-field>

            <xi-checkbox
              [label]="t('include')"
              color="CX"
              formControlName="includeMinimum"
            ></xi-checkbox>

            <label [id]="'max-value-' + i">{{ t('max') }}</label>
            <xi-input-field
              type="number"
              formControlName="maximumValue"
              [inputId]="'max-value-' + i"
              [step]="numericStep()"
              (onBlur)="updateErrorSignal()"
              (onChange)="onNumericValueChange(row, 'maximumValue', $event.detail.target.value)"
            ></xi-input-field>

            <xi-checkbox
              [label]="t('include')"
              color="CX"
              formControlName="includeMaximum"
            ></xi-checkbox>
          </div>
        </div>
        @if (!isReadOnly()) {
          <div class="field-buckets__item-right">
            <div>
              <xi-icon-button icon="cancel_circle" (onClick)="onDeleteItem(i)"></xi-icon-button>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (formErrorState().length > 0) {
    <div class="validation-errors-container table-error">
      @for (error of formErrorState(); track error) {
        <div class="error-message">{{ error }}</div>
      }
    </div>
  }
</form>
